import { NgModule } from '@angular/core';
import { CompatAccessibilityComponent } from './compat-accessibility.component';

@NgModule({
  declarations: [CompatAccessibilityComponent],
})
export class CompatAccessibilityModule {}
